import { ContactUs as ContactUsUI } from "features";

const ContactUs = () => {
  return (
    <>
      <ContactUsUI />
    </>
  );
};
export { ContactUs };
